import * as React from 'react';
export class ColumnRenderer extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.container = null;
        this.handleRef = (ref) => {
            this.container = ref;
        };
        this.clamp = (index, deltaY) => {
            if (this.container) {
                const minHeight = this.props.floatyManager.getColumnMinHeight();
                const heightA = this.container.children[index * 2].getBoundingClientRect().height;
                const heightB = this.container.children[index * 2 + 2].getBoundingClientRect().height;
                const minimum = minHeight - heightA;
                const maximum = heightB - minHeight;
                return Math.min(maximum, Math.max(minimum, deltaY));
            }
            return null;
        };
        this.handleMove = (index, deltaY) => {
            if (this.container) {
                const heightA = this.container.children[index * 2].getBoundingClientRect().height;
                const heightS = this.container.children[index * 2 + 1].getBoundingClientRect().height;
                const heightB = this.container.children[index * 2 + 2].getBoundingClientRect().height;
                const heightTotal = heightA + heightS + heightB;
                const fractionA = heightA / heightTotal;
                const fractionS = heightS / heightTotal;
                const fractionB = heightB / heightTotal;
                const fractionTotal = fractionA + fractionS + fractionB;
                const deltaF = fractionTotal * deltaY / heightTotal;
                const fractionOriginal = this.props.column.items[index].fraction + this.props.column.items[index + 1].fraction;
                const normalizer = fractionOriginal / (fractionA + fractionB);
                this.props.floatyManager.updateColumnFractions(this.props.column, index, normalizer * (fractionA + deltaF), index + 1, normalizer * (fractionB - deltaF));
            }
        };
    }
    render() {
        const gridTemplateRows = [];
        const elements = [];
        const minimumFraction = this.props.column.items.reduce((previous, item) => Math.min(previous, item.fraction), Number.POSITIVE_INFINITY);
        for (let i = 0; i < this.props.column.items.length; i++) {
            if (i > 0) {
                gridTemplateRows.push('max-content');
                elements.push(React.createElement(this.props.floatyRenderers.columnSeparatorRenderer, { key: `${i}-seperator`, floatyRenderers: this.props.floatyRenderers, index: i - 1, onMove: this.handleMove, clamp: this.clamp }));
            }
            gridTemplateRows.push(`minmax(${this.props.floatyManager.getColumnMinHeight()}px, ${this.props.column.items[i].fraction / minimumFraction}fr)`);
            elements.push(React.createElement(this.props.floatyRenderers.layoutRenderer, { key: i, floatyRenderers: this.props.floatyRenderers, floatyManager: this.props.floatyManager, layout: this.props.column.items[i].child }));
        }
        return React.createElement("div", { ref: this.handleRef, style: { display: 'grid', gridTemplateRows: gridTemplateRows.join(' '), gridTemplateColumns: 'minmax(0, 100%)' } }, elements);
    }
}
//# sourceMappingURL=column-renderer.js.map